<template>
  <div class="half-height table">
  	<div class="table-cell">
	    <p class="text-extended text-center text-largest-2 lh-1">
	    	<strong>4O4 <span class="text-mono text-larger blink">&rarr;</span> Not Found</strong>
	    </p>
	</div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
